export type EntityType =
  | 'monster'
  | 'tile'
  | 'particle'
  | 'particle-spawner'
  | 'tile-selector'
  | 'cursor'
  | 'dialog'
  | 'stevie-text'
  | 'button'
  | 'num-selector'
  | 'text-input'
  | 'path-highlight'
  | 'object'
  | 'health-bar'
  | 'tile-map-ship'
  | 'tile-ship'
  | 'starmap'
  | 'tile-starmap'
  | 'cargo'
  | 'machine'
  | 'machine-part'
  | 'job'
  | 'job-creator'
  | 'stack'
  | 'asteroid'
  | 'blueprint'
  | 'blueprint-part'
  | 'fullness-indicator'
  | 'progress-indicator'
  | 'build-selector'
  | 'stack-selector'
  | 'machine-placer'
  | 'machine-placer-part'
  | 'portrait'
  | 'death-punch-enemy'

export interface IEntity {
  id: number
  isDead: boolean
  eType: EntityType
}
export interface IDeadish extends IEntity {
  isDying?: boolean
}

export interface IEntityWithPlayerNumber extends IEntity {
  playerNumber: number
}

export function findById<T extends IEntity>(id: number, objs: T[]): T | null {
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].id === id) {
      return objs[i]
    }
  }
  // console.log('WARN', 'findById', 'entity not found', id)
  debugger
  return null
}

export function findByPlayerNumber<T extends { playerNumber: number }>(
  playerNumber: number,
  objs: T[],
): T | null {
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].playerNumber === playerNumber) {
      return objs[i]
    }
  }
  // debugger
  return null
}

export function removeDead<T extends IEntity>(
  objs: T[],
  onRemove: (obj: T) => any,
) {
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].isDead) {
      onRemove(objs[i])
      objs.splice(i, 1)
      i--
    }
  }
}

export function isDeadish(obj: IDeadish) {
  return obj.isDead || obj.isDying
}

// export function removeBy(
//   objs: IEntity[],
//   filter: (obj: IEntity) => boolean,
//   onRemove: (obj: IEntity) => any,
// ) {
//   for (let i = 0; i < objs.length; i++) {
//     if (filter(objs[i])) {
//       onRemove(objs[i])
//       objs.splice(i, 1)
//       i--
//     }
//   }
// }
